<template lang="html">
  <div class="result-tip">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ResultTip'
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.result-tip {
  text-align: center;
  font-size: use(30);
  line-height: use(50);
  color: #666666;
  border-bottom: 1px solid #E8E8E8;
  padding-top: use(43);
  padding-bottom: use(56);
}
</style>
